/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PaymentMethodAuthorisePathParams,
	PaymentMethodAuthoriseRequest,
	PaymentMethodAuthoriseResponse,
} from '../types/PaymentMethodAuthorise'

/**
 * POST /:organisation/campaigns/:campaign/payment-methods/:paymentMethod/authorise
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::authorise
 */
export async function paymentMethodAuthorise(
	organisation: PaymentMethodAuthorisePathParams['organisation'],
	campaign: PaymentMethodAuthorisePathParams['campaign'],
	paymentMethod: PaymentMethodAuthorisePathParams['paymentMethod'],
	data: PaymentMethodAuthoriseRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodAuthoriseResponse>> {
	return axiosInstance.post(
		`/${organisation}/campaigns/${campaign}/payment-methods/${paymentMethod}/authorise`,
		data,
		config,
	)
}
